import React, { ReactNode } from 'react';
import styled from 'styled-components';

const TableCellWrapper = styled.td`
    padding: 16px;
    border-bottom: 1px solid #ddd;
`;

interface TableCellProps {
    children: ReactNode;
}

export const TableCell: React.FC<TableCellProps> = ({ children }) => {
    return <TableCellWrapper>{children}</TableCellWrapper>;
};
